import { z } from 'zod';
/**
 * Branded identifier schemas.
 *
 * Every id is a UUID at runtime and a *distinct type* at compile time, so a `UserId` cannot be
 * passed where a `TaskId` is expected (rules/zod-validation.mdc, rule 10). One mechanism only —
 * Zod's `.brand()` — so there is exactly one definition of `UserId` in the codebase and the type
 * is inferred from the schema instead of being written twice.
 *
 * The list grows with the domain: an id is added here together with the epic that introduces its
 * entity, using the entity name from `docs/product/glossary.md`.
 */
const brandedUuid = () => z.uuid({ error: 'validation.id.invalid' }).brand();
export const organizationIdSchema = brandedUuid();
export const userIdSchema = brandedUuid();
export const teamIdSchema = brandedUuid();
export const roleIdSchema = brandedUuid();
export const invitationIdSchema = brandedUuid();
export const projectIdSchema = brandedUuid();
export const boardIdSchema = brandedUuid();
export const taskIdSchema = brandedUuid();
export const sprintIdSchema = brandedUuid();
export const commentIdSchema = brandedUuid();
export const docIdSchema = brandedUuid();
export const fileIdSchema = brandedUuid();
export const timeEntryIdSchema = brandedUuid();
/**
 * Factories for the ids that already have call sites. They `parse` rather than `safeParse`: an id
 * that is not a UUID at this point is a programming error, not user input — user input reaches an
 * id through a request validator, which reports it as `validation_failed`.
 */
export const asOrganizationId = (value) => organizationIdSchema.parse(value);
export const asUserId = (value) => userIdSchema.parse(value);
export const asProjectId = (value) => projectIdSchema.parse(value);
export const asTaskId = (value) => taskIdSchema.parse(value);
//# sourceMappingURL=entity-id.schema.js.map